import { Link, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';
import { useAuth } from '../context/AuthContext';
import LoginButton from './LoginButton';
import UserMenu from './UserMenu';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const location = useLocation();
  const { user, loading } = useAuth();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/battle', label: 'Battle' },
    { path: '/leaderboard', label: 'Leaderboard' },
  ];

  return (
    <div className="min-h-screen flex flex-col">
      {/* Header */}
      <header className="border-b border-arena-border">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <span className="text-2xl">🎬</span>
            <span className="font-bold text-xl">Video AI Arena</span>
          </Link>

          <div className="flex items-center gap-6">
            <nav className="flex items-center gap-6">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors ${
                    location.pathname === link.path
                      ? 'text-arena-accent'
                      : 'text-arena-muted hover:text-arena-text'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            {/* Auth: Login button or User menu */}
            {!loading && (
              user ? <UserMenu /> : <LoginButton />
            )}
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        {children}
      </main>

      {/* Footer */}
      <footer className="border-t border-arena-border py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-arena-muted text-sm">
              Video AI Arena - Compare video AI models head-to-head
            </div>
            <div className="flex items-center gap-6 text-sm text-arena-muted">
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-arena-text transition-colors"
              >
                GitHub
              </a>
              <a
                href="https://contentindexer.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-arena-text transition-colors"
              >
                Powered by ContentIndexer
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
